import './style/index';

import _Swiper from './swiper';

export type { SwiperProps } from './swiper';

export const Swiper = _Swiper;
export default Swiper;

export * from './type';
